import { inject, Injectable } from '@angular/core';
import { RoamingDataApiRoaming } from '@api-roaming/models/roaming-data-api-roaming';
import { UserState } from '@core/state/user.state';
import { CurrencyFormatService } from '@shared/services/currency-format.service';


/**
 * User Currency Format Settings Instance Service
 */
@Injectable()
export class CurrencyInitService {
    readonly #userState: UserState = inject(UserState);
    readonly #formatService: CurrencyFormatService = inject(CurrencyFormatService);

    public init(): Promise<void> {
        this.#userState.userRoaming$.subscribe((user: RoamingDataApiRoaming) => {
            this.#formatService.setFormat(user ? user.currencyFormat : undefined);
        });
        // eslint-disable-next-line  @typescript-eslint/typedef, padding-line-between-statements
        return new Promise<null>((resolve): void => {
            resolve(null);
        });
    }
}

export function currencyInitFactory(service: CurrencyInitService): () => void {
    return () => service.init();
}
